import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import {
    IAcquireLockRequestBody,
    IAcquireLockRequestHeaders,
    IAcquireLockRequestParams,
    IAcquireLockResponse,
} from '../../../entity/interface/iStreamHarness';
import { IStreamHarnessRepository } from '../../repositories/interfaces/iStreamHarnessRepository';

export interface IAcquireLockUseCase {
    execute(
        params: IAcquireLockRequestParams,
        payload: IAcquireLockRequestBody,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse>;
}

export class AcquireLockUseCase implements IAcquireLockUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get streamHarnessRepo(): IStreamHarnessRepository {
        return container.resolve<IStreamHarnessRepository>(DI.REPOSITORIES.IStreamHarnessRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        params: IAcquireLockRequestParams,
        payload: IAcquireLockRequestBody,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse> {
        return await this.streamHarnessRepo.acquireLock(params, payload, headers);
    }
}
